import React, {Component} from 'react';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import Search from 'material-ui/svg-icons/action/search';
import Download from 'material-ui/svg-icons/file/file-download';
import RetivaActions from '../../reflux/RetIvaActions';
import RetivaStore from '../../reflux/stores/RetIvaStore';
import Input from '../../components/Forms/Input.jsx';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';

class RetIvaReport extends Component {
    constructor(props) {
        super(props);

        //Get the current's month first and last day
        let date = new Date(), y = date.getFullYear(), m = date.getMonth();
        let firstDay = new Date(y, m, 1);
        let lastDay = new Date(y, m + 1, 0);

        this.state = {
            retivas: [],
            desde:firstDay,
            hasta:lastDay,
        };

        this.handleRetiva = this.handleRetiva.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    
    componentWillMount() {
        let desde = this._date(this.state.desde, true),
            hasta = this._date(this.state.hasta, true);

        RetivaActions.getReport(desde, hasta);
    }
    
    componentDidMount() {
        this.unsubscribe = RetivaStore.listen(this.handleRetiva);
    }

    componentWillUnmount() {
        this.unsubscribe();
    }
    
    /**
     * Get retivas fromt he specified period of time
     * 
     */
    handleSearch(download) {
        let desde = this._date(this.state.desde, true),
            hasta = this._date(this.state.hasta, true);

        RetivaActions.getReport(desde, hasta, download);
    }

    /**
     * Handles the change of any of the DatePickers
     * 
     * @param {Object} e The change event
     * @param {Mixed} value The value of the DatePickers
     * 
     */
    handleChange(e, value) {
        if (e.target.name === 'desde')
            this.setState({desde: value});
        if (e.target.name === 'hasta')
            this.setState({hasta: value});
    }

    /**
     * Handles changes int he RetIvaStore
     * 
     * @param {string} e The event that is being fired
     * @param {Array.<Retiva>} data Array of retivas 
     * 
     */
    handleRetiva(e, data) {
        if (e === 'getReport') {
            this.setState({retivas: data});
        }
    }

    /**
     * Formats the date in either local format '30-06-2016' or USA format '2016-06-30'
     * 
     * @param {Object} fecha A Date object
     * @param {boolean} usa Specified if the output should be usa format
     * 
     */
    _date(fecha, usa) {
            let day = fecha.getUTCDate() < 10 ? '0' + fecha.getUTCDate() : fecha.getUTCDate(),
                month = (fecha.getUTCMonth() + 1) < 10 ? '0' + (fecha.getUTCMonth() + 1) : fecha.getUTCMonth() + 1,
                year = fecha.getUTCFullYear();
            if (usa) return year + '-' + month + '-' + day;   
            return day + '-' + month + '-' + year;
    }
    render() {

        //REDECLARE TABLE ELEMENTS SO THEY ARE SHORTER TO USE
        const TR = (props) => <TableRow {...props} />;
        const TD = (props) => <TableRowColumn {...props} />;
        const TH = (props) => <TableHeaderColumn {...props} />;
        const numberStyle = {textAlign: 'right'};
        const missingStyle = {background:'#FF8A65'};
        
        //Initialize the grand total variable
        let total = 0;

        //Map through all retivas to create each line
        const lines = this.state.retivas.map(
            (retiva, index) => {
                let rowStyle = null;
                let trow = [];

                //If the retiva is a duplicate color the backgroung pink
                if (retiva.duplicate) rowStyle = {background: 'pink'};
                total += retiva.total_retenido;

                //Create the line
                trow.push(
                    <TR style={rowStyle} key={retiva.id}>
                        <TD>{retiva.numeroRet}</TD>
                        <TD>{retiva.date}</TD>
                        <TD>{retiva.proveedor.name}</TD>
                        <TD style={numberStyle}>{parseFloat(retiva.total_retenido).fmtd()}</TD>
                    </TR>);

                //If the following retiva's number is not the one that should go,
                //add a blank line specifying that a retiva is missingStyle
                if (index < this.state.retivas.length-1
                 && retiva.number+1 !== this.state.retivas[index+1].number 
                 && (!this.state.retivas[index+1].duplicate
                 || this.state.retivas[index+1] && !retiva.duplicate)) {
                 trow.push( 
                        <TR style={missingStyle} key={retiva.id+'b'}>
                            <TD>FALTA</TD>
                            <TD>FALTA</TD>
                            <TD>FALTA</TD>
                            <TD style={numberStyle}>FALTA</TD>
                        </TR>);   
                    
                }
                
                //Return The line/s
                return (
                    trow
                );
        });

        //RetIvaReport Renders
        return (
            <div style={{marginTop:40}}>
            <h2>Reporte de retenciones de I.V.A. por rango de fechas</h2>
            <Paper className="no-print" style={{marginBottom:15, padding:'0px 20px 20px 20px'}}>
                <div className="row">
                    <div className="col-xs-4">
                        <Input
                            formatDate={this._date}
                            validations="required"
                            onChange={this.handleChange}
                            val={this.state.desde}
                            fullWidth={true} 
                            name="desde"
                            floatingLabelText="Desde"
                            date={true}
                        />
                    </div>

                    <div className="col-xs-4">
                        <Input
                            formatDate={this._date}
                            validations="required"
                            onChange={this.handleChange}
                            val={this.state.hasta}
                            fullWidth={true} 
                            name="hasta"
                            floatingLabelText="Hasta"
                            date={true}
                        />
                    </div>
                    
                </div>

                <div className="row">
                    <div className="col-xs-4" style={{position:'relative'}}>
                        <RaisedButton
                            onTouchTap={this.handleSearch.bind(this, false)}
                            primary={true}
                            icon={<Search />}
                            style={{marginRight:10,marginBottom:5}}
                            label="Buscar"
                        />
                        <RaisedButton
                            onTouchTap={this.handleSearch.bind(this, true)}
                            primary={true}
                            icon={<Download />}
                            label="Descargar TXT"
                        />
                    </div>
                </div>

                <div>
                Leyenda: 
                <span style={{color:'#e46178', fontWeight:800}}>  Duplicados</span>,
                <span style={{color:'#FF8A65', fontWeight:800}}>  Faltantes</span>
                </div>
            </Paper>
            <Paper>
                <Table selectable={false}>
                    <TableHeader
                        displaySelectAll={false}
                        selectable={false}
                        adjustForCheckbox={false}
                    >
                        <TR>
                            <TH>N° Comprobante</TH>
                            <TH>Fecha</TH>
                            <TH>Proveedor</TH>
                            <TH>Total Retenido</TH>
                        </TR>
                    </TableHeader>

                    <TableBody displayRowCheckbox={false}>
                        {lines}
                        <TR>
                            <TD></TD>
                            <TD></TD>
                            <TD style={{textAlign:'right', fontSize:15, fontWeight:600}}>Total retenido en el período:</TD>
                            <TD style={{textAlign:'right', fontSize:15, fontWeight:600}}>{total.fmtd()}</TD>
                        </TR>
                    </TableBody>
                </Table>
                </Paper>
            </div>
        );
    }
}

export default RetIvaReport;


/** WEBPACK FOOTER **
 ** ./app-react/pages/RetIva/RetIvaReport.jsx
 **/